var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.get_class},[(_vm.display_value.length > 0)?_c('div',[_vm._l((_vm.display_value),function(orders,index){return [_c('div',{key:index},[_vm._v("\n        "+_vm._s(orders.date_invoiced ? orders.date_invoiced + "\n" : "None \n")+"\n      ")])]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }